// const api = '/api/'
// const dev = 'http://127.0.0.1:8000/'
// let isDev = false
// const url = isDev?dev:api
// export default {
//     getBlogList:url+'blogList',
//     getArticle:url+'blogArticle/',
//     getProcess:url+'blogProcess',
//     getTargets:url+'blogTargets',
//     getBlogLife:url+'blogLife',
//     getAbout:url+'blogAbout'
// }
// const api = '/api/'
// const dev = 'http://127.0.0.1:8000/'
// let isDev = false
// const url = isDev?dev:api
export default {
    getBlogMeta:'blogMeta',
    getBlogList:'blogList',
    getArticle:'blogArticle/',
    getProcess:'blogProcess',
    getTargets:'blogTargets',
    getBlogLife:'blogLife',
    getAbout:'blogAbout',
    getTagList:'blogTag/',
    getArticleStatistic:'blogStatistic',
    getTags:'blogTag',
    getWords:'blogWord',
    login:'login',
    adminPostList:'admin/post',
    adminTalk:'admin/talk',
    adminAbout:'admin/about',
    adminMeta:"admin/meta",
    adminTags:"admin/tags"
}